export default (link) => ({
  copied: false,
  timer: null,
  copy() {
    if (!navigator.clipboard) {
      try {
        const textArea = document.createElement("textarea");
        textArea.value = link;
        textArea.style.opacity = 0;
        textArea.style.position = "fixed";
        textArea.style.height = 0;
        textArea.style.width = 0;
        textArea.ariaHidden = true;

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        this.copied = document.execCommand("copy");

        document.body.removeChild(textArea);
        this.startCountdown();
      } catch (err) {}
    } else {
      navigator.clipboard.writeText(this.decodeHtmlEntities(link)).then(
        () => {
          this.copied = true;
          this.startCountdown();
        },
        (err) => {}
      );
    }
  },
  decodeHtmlEntities(str) {
    const textArea = document.createElement("textarea");
    textArea.innerHTML = str;
    return textArea.value;
  },
  startCountdown() {
    if (!this.copied || this.timer) {
      return;
    }
    this.timer = setTimeout(() => {
      this.copied = false;
      this.timer = null;
    }, 3000);
  },
});
